import { leafetLayer } from 'ui/map/config';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-fullscreen';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import { GestureHandling } from 'leaflet-gesture-handling';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
import $ from "jquery";

export default class LeafetMap {
    layer() {
        return leafetLayer;
    }

    controlPosition() {
        return 'topleft';
    }

    makeMap(element, config) {
        const cfg = config
            ? {
                  center: config.center,
                  gestureHandling: config.gestureHandling,
                  zoom: 13,
                  zoomControl: false,
              }
            : {};

        return new L.Map(element, cfg);
    }

    makeMarker(marker = {}) {
        return L.icon(
            marker
                ? marker
                : {
                      iconSize: [30, 50],
                      iconAnchor: [15, 50],
                      iconUrl: '/theme/images/map/pin.svg',
                      shadowUrl: '/theme/images/map/pin.svg',
                  }
        );
    }

    constructor(element, config) {
        this.remove = false;
        this.markerIcon = this.makeMarker(config.marker || null);

        const myStyle = {
            color: '#df362a',
            fillColor: '#df362a',
            opacity: 0.5,
            fillOpacity: 0.33,
        };
        L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
        L.Path.mergeOptions(myStyle);
        L.Polyline.mergeOptions(myStyle);
        L.Polygon.mergeOptions(myStyle);
        L.Rectangle.mergeOptions(myStyle);
        L.Circle.mergeOptions(myStyle);
        L.CircleMarker.mergeOptions(myStyle);

        this.map = this.makeMap(element, config);
        this.layer().addTo(this.map);

        if (config.fullscreen) {
            this.map.addControl(
                new L.Control.Fullscreen({
                    position: this.controlPosition(),
                    title: {
                        false: 'Во весь экран',
                        true: 'Выйти из полноэкранного режима',
                    },
                })
            );
        }

        L.control.zoom({ position: this.controlPosition() }).addTo(this.map);

        let bounds = window.BaseApp.initData.mapConfig.bounds || null;

        if (bounds) {
            bounds = L.latLngBounds(
                [bounds.leftTop.y, bounds.leftTop.x],
                [bounds.rightBottom.y, bounds.rightBottom.x]
            );

            this.map.setMaxBounds(bounds);
        }

        const minZoom = window.BaseApp.initData.mapConfig.minZoom || null;
        const maxZoom = window.BaseApp.initData.mapConfig.maxZoom || null;

        if (minZoom){
            this.map.setMinZoom(minZoom);
        }

        if (maxZoom){
            this.map.setMaxZoom(maxZoom);
        }

        const resizeObserver = new ResizeObserver(() => {
            if (!this.remove) {
                this.map.invalidateSize();
            }
        });
        resizeObserver.observe(element);
    }

    remove() {
        this.remove = true;
        this.map.remove();
    }

    removeLayer(layer) {
        this.map.removeLayer(layer);
    }

    add(geoJson) {
        let _layer;
        L.geoJSON(geoJson, {
            style: (feature) => feature.properties.style,
            pointToLayer: (feature, latlng) => {
                this.map.panTo(latlng);
                let marker = null;
                if (!feature.properties.marker) {
                    marker = L.marker(latlng, { icon: this.markerIcon });
                } else {
                    marker = L.marker(latlng, {
                        icon: L.icon({
                            shadowUrl: null,
                            iconAnchor: new L.Point(15, 50),
                            iconSize: new L.Point(30, 50),
                            iconUrl: feature.properties.marker,
                        }),
                    });
                }
                return marker;
            },
            onEachFeature: (feature, layer) => {
                if (!(layer instanceof L.Marker)) {
                    this.map.fitBounds(layer.getBounds());
                }
                _layer = layer;
            },
        }).addTo(this.map);

        return _layer;
    }
}
